





























import Vue from 'vue';
import { mapActions } from 'vuex';
import { BFormCheckbox } from 'bootstrap-vue';
import GenericCard from '@/components/cards/GenericCard.vue';
import { ModalSize } from '@/components/zen_modal/types';

export default Vue.extend({
  name: 'DashboardDeleteCard',
  components: {
    BFormCheckbox,
    GenericCard,
  },
  props: {
    dashboardElement: {
      type: String,
      required: false,
      default: 'Dashboard Element',
    },
  },
  data() {
    return {
      confirmed: <boolean>false,
    };
  },
  created() {
    this.changeModalSize(ModalSize.Small);
  },
  methods: {
    ...mapActions({
      changeModalSize: 'modals/changeSize',
      cancelModal: 'modals/cancel',
      confirmModal: 'modals/confirm',
    }),
    confirmDeletion() {
      if (!this.confirmed) return;
      this.confirmModal();
    },
  },
});
